import { Routes } from '@angular/router';
import { Welcome } from './views/welcome/welcome';
import { SecurityKeyLogin } from './views/authorization/security-key-login/security-key-login';
import { HomeOptions } from './views/home-options/home-options';
import { ComponentCatalog } from './views/component-catalog/component-catalog';
import { AgileLogin } from './views/authorization/agile-login/agile-login';
import { UpdatePersonalDataComponent } from './views/update-personal-data/update-personal-data';
import { Certificates } from './views/certificates/certificates';
import { GenericCertificate } from './views/certificates/generic-certificate/generic-certificate';
import { authGuard } from './commons/guards/auth.guard';

export const routes: Routes = [
    {path: "", component: Welcome},
    {path: "security-key-login", component: SecurityKeyLogin},
    {path: "agile-login", component: AgileLogin},
    {path: "home-options", component: HomeOptions, canActivate: [authGuard]},
    {path: "component-catalog", component: ComponentCatalog},
    {path: "update-personal-data", component: UpdatePersonalDataComponent, canActivate: [authGuard]},
    {path: "certificates", component: Certificates, canActivate: [authGuard]},
    {path: "certificates/:certificateId", component: GenericCertificate, canActivate: [authGuard]},
];
